import { render, staticRenderFns } from "./company-lookup.vue?vue&type=template&id=f012a2c6&"
import script from "./company-lookup.vue?vue&type=script&lang=js&"
export * from "./company-lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports